import type { SetupFee_ComprovanteRow } from '../../contracts/SetupFee_ComprovanteRow';

/**
 * Valor do comprovante na moeda dele, com `n()` do vue-i18n (a regra do projeto para moeda).
 * valor_cents é sempre o valor digitado × 100 (ComprovanteDoSetup::centavos), em qualquer moeda.
 */
export const valorDoComprovante = (
  c: Pick<SetupFee_ComprovanteRow, 'valor_cents' | 'moeda'>,
  n: (valor: number, opcoes: Intl.NumberFormatOptions) => string,
): string => n((c.valor_cents ?? 0) / 100, { style: 'currency', currency: c.moeda || 'BRL' });

/** AAAA-MM-DD → DD/MM/AAAA, sem passar por Date (data sem hora não sofre fuso). */
export const dataDoComprovante = (iso: string | undefined | null): string => {
  if (!iso) return '';
  const [a, m, d] = iso.slice(0, 10).split('-');
  return `${d}/${m}/${a}`;
};
